import { supportedCurrencies } from '../../utils';

/**
 * Country → account currency for sign-up.
 *
 * `country-state-city` carries an ISO 4217 code on every country (`IE` → `EUR`,
 * `US` → `USD`, `IN` → `INR`). We only bill in four of them, so anything outside
 * that set falls back to USD rather than being stored as a currency the pricing
 * pages, Stripe products and order records have no figures for.
 *
 * Pure so it can be tested without mounting the profile editor.
 */

export const DEFAULT_CURRENCY = 'usd';

/**
 * Map a country's ISO 4217 code to one of the currencies we support.
 *
 * The library's `currency` is typed as a required string but comes from bundled
 * data, so treat a missing or blank value as simply unsupported.
 */
export const currencyForCountry = (countryCurrency?: string | null): string => {
	const code = (countryCurrency ?? '').trim().toLowerCase();
	return supportedCurrencies.includes(code) ? code : DEFAULT_CURRENCY;
};
